import { z } from 'zod';

export const ASSISTANT_FIELD_LABELS: Record<string, string> = {
  'applicant.employment.type': 'How do you earn your income?',
  'applicant.employment.employed.employerBusinessName': 'Employer business name',
  'applicant.employment.employed.abn': 'Employer ABN',
  'applicant.employment.employed.employerPhoneNumber': 'Employer phone number',
  'applicant.employment.employed.jobTitle': 'Job title',
  'applicant.employment.selfEmployed.jobTitle': 'Job title',
  'applicant.employment.selfEmployed.phone': 'Business phone number',
  'applicant.employment.selfEmployed.isSameMobileNumber': 'Business phone is the same as mobile',
  'applicant.employment.pensioner.pensionType': 'Pension type',
  'applicant.employment.selfEmployed.abn': 'Business ABN',
  'applicant.employment.selfEmployed.entityName': 'Business trading name',
  'applicant.income.additional.period': 'Additional income frequency',
  'applicant.income.primary.documentIds': 'Primary income documents',
  'applicant.income.additional.documentIds': 'Additional income documents',
  'applicant.employment.other': 'How do you earn your income? (other)',
  'applicant.income.primary.amount': 'Primary income (after tax)',
  'applicant.income.primary.period': 'Income frequency',
  'applicant.income.isAdditionalIncome': 'Do you have other sources of income?',
  'applicant.income.additional.amount': 'Additional income amount',
  'applicant.usingOpenBanking': 'Income verification method',
  incomeVerification: 'Income verification documents',
};

export const ASSISTANT_INCOME_VALUE_FIELDS: readonly string[] = [
  'applicant.employment.type',
  'applicant.employment.pensioner.pensionType',
  'applicant.income.primary.amount',
  'applicant.income.primary.period',
  'applicant.income.isAdditionalIncome',
  'applicant.income.additional.amount',
  'applicant.income.additional.period',
];

export const assistantFormContextSchema = z
  .array(
    z.object({
      fieldName: z.string().min(1).max(120),
      filled: z.boolean(),
      changed: z.boolean(),
      /** The field is currently showing a validation error on screen. */
      invalid: z.boolean().optional(),
      value: z.string().max(64).nullish(),
    }),
  )
  .max(50);

export type AssistantFormField = z.infer<typeof assistantFormContextSchema>[number];

export const ASSISTANT_EVENT_TYPES = [
  'step_entered',
  'validation_failed',
  'save_error',
  'verification_failed',
  'rapid_clicks',
  'error_explained',
] as const;

export const ASSISTANT_ERROR = {
  expired: 'ASSISTANT_CONVERSATION_EXPIRED',
  busy: 'ASSISTANT_CONVERSATION_BUSY',
  conflict: 'ASSISTANT_REQUEST_CONFLICT',
  unknownOutcome: 'ASSISTANT_REQUEST_OUTCOME_UNKNOWN',
  unavailable: 'ASSISTANT_UNAVAILABLE',
  rateLimited: 'ASSISTANT_RATE_LIMITED',
} as const;
